var exports = {
  "u": "statusAvatarBackground__rYNX3r",
  "m": "statusAvatar__S2Xk7F",
};

module.exports = exports;
